import { useEffect, useRef } from "react";
import Button from "./button";

const Dialog = ({
  isOpen,
  onClose,
  title,
  description,
  inputPlaceholder,
  submitLabel,
  onSubmit,
}) => {
  const dialogRef = useRef(null);
  const inputRef = useRef(null);

  // Handle opening/closing of dialog, and clear input
  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return undefined;

    if (isOpen) {
      if (!dialog.open) {
        dialog.showModal();
      }
    } else {
      if (dialog.open) {
        dialog.close();
      }
    }
    inputRef.current.value = "";
  }, [isOpen]);

  const handleBackdropClick = (event) => {
    if (event.target === dialogRef.current) {
      onClose();
    }
  };

  const handleCancel = (event) => {
    event.preventDefault();
    onClose();
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const currentValue = inputRef.current.value;
    onSubmit(currentValue);
    inputRef.current.value = "";
  };

  return (
    <dialog
      ref={dialogRef}
      className="dialog"
      aria-labelledby="dialog-title"
      onClick={handleBackdropClick}
      onCancel={handleCancel}
    >
      <div className="dialog__content">
        <form className="dialog__form" onSubmit={handleSubmit}>
          <h2 id="dialog-title" className="dialog__title">
            {title}
          </h2>
          <p className="dialog__description">{description}</p>
          <input
            ref={inputRef}
            className="dialog__input"
            type="text"
            name="dialog-input"
            placeholder={inputPlaceholder}
          />
          <Button
            className="dialog__submit"
            type="submit"
            label={submitLabel}
          />
        </form>
      </div>
    </dialog>
  );
};

export default Dialog;
